export function normalizeCategory(category) {
    if ('coverMedia' in category) {
        return normalizePlatformizedCategory(category);
    }
    return normalizeCategoryV3(category);
}
function normalizeCategoryV3(category) {
    return {
        id: category.id,
        label: category.label,
        slug: category.slug,
        menuLabel: category.label,
        description: category.description,
        cover: category.coverImage,
        displayPosition: category.displayPosition,
        coverType: category.coverImage ? 'image' : 'none',
        language: category.language ?? '',
        postAmount: category.postCount,
        seoData: category.seoData,
        slugs: [category.slug],
        translations: category.translations,
    };
}
function normalizePlatformizedCategory(category) {
    return {
        id: category.id,
        menuLabel: category.label,
        description: category.description,
        label: category.label,
        slug: category.slug,
        cover: category.coverImage,
        displayPosition: category.displayPosition,
        coverType: category.coverImage ? 'image' : 'none',
        language: category.language,
        postAmount: category.postCount,
        seoData: category.seoData,
        slugs: category.slug ? [category.slug] : [],
        translations: [],
    };
}
//# sourceMappingURL=normalize-category.js.map